











































































import { Component, Prop } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    FilledButton,
    GhostButton,
    CoinNetworkFeatureTag
  }
})
export default class CustomerImportWelcome extends BillingModel {
  @Prop(Number) numberOfCustomers!: number;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: false }) hideSkip?: boolean;
  @Prop({ default: false }) modal?: boolean;

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  onClickCTA() {
    if (this.inactiveBilling) {
      this.onClickUpgrade({
        onSuccess: () => {
          this.$emit('submit');
        },
        props: {
          welcomeCtaText: 'Explore Import Customers',
          origin: 'Empty State Import Customers'
        }
      });
    }
    this.$emit('submit');
  }
}
